import { socialProof } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './SocialProof.css';

export function SocialProof() {
  return (
    <Section id="prueba-social" title={socialProof.title} lead={socialProof.lead} className="social-section">
      <ScrollReveal>
        <p className="social-section__kicker">Sectores habituales</p>
        <ul className="social-industries" aria-label="Tipos de negocio que atienden por chat">
          {socialProof.industries.map((name) => (
            <li key={name} className="social-industries__item">
              {name}
            </li>
          ))}
        </ul>
      </ScrollReveal>
    </Section>
  );
}
